import { Button } from '@/components/ui/button'
import { RefreshCw } from 'lucide-react'

// Props interface aligns with what CatchBoundary expects for errorComponent
type ErrorBoundaryProps = {
  error: Error
  reset: () => void
}

export const ErrorBoundary = ({ error, reset }: ErrorBoundaryProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <div className="max-w-md space-y-4">
        <h1 className="text-3xl font-bold tracking-tight">
          Something went wrong
        </h1>
        <div className="p-4 border rounded-md bg-red-50 border-red-200">
          <p className="text-sm font-medium text-red-800">
            {error.message || 'An unexpected error occurred'}
          </p>
          {import.meta.env.DEV && (
            <pre className="mt-2 text-xs text-left text-red-700 overflow-auto max-h-32">
              {error.stack}
            </pre>
          )}
        </div>
        <Button onClick={reset} className="inline-flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          Try again
        </Button>
      </div>
    </div>
  )
}
